/**
 * HELP-16685: Real-user INP attribution logging.
 * Uses the self-hosted web-vitals v5 attribution build (web-vitals-attribution.js)
 * to report WHICH interaction drives INP for real users, since CrUX only gives
 * the aggregate number. Data goes to:
 *  - GTM dataLayer (event: "inp_attribution") for GA4 forwarding
 *  - Microsoft Clarity custom tags/events, filterable in the Clarity dashboard
 * Remove this file and web-vitals-attribution.js once the INP work is done.
 */
(function () {
  if (!window.webVitals || !window.webVitals.onINP) return;

  window.webVitals.onINP(function (metric) {
    var a = metric.attribution || {};
    var value = Math.round(metric.value);
    var payload = {
      event: 'inp_attribution',
      inp_value: value,
      inp_rating: metric.rating,
      inp_target: a.interactionTarget || '(not set)',
      inp_event_type: a.interactionType || '(not set)',
      inp_input_delay: Math.round(a.inputDelay || 0),
      inp_processing: Math.round(a.processingDuration || 0),
      inp_presentation: Math.round(a.presentationDelay || 0),
      inp_load_state: a.loadState || '(not set)',
      inp_page: location.pathname
    };

    try {
      var script = a.longestScript && a.longestScript.entry;
      if (script) {
        payload.inp_longest_script = script.sourceURL || script.name || '(inline)';
        payload.inp_longest_script_ms = Math.round(a.longestScript.intersectingDuration || script.duration || 0);
      }
    } catch (e) {
      /* attribution internals are best-effort */
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (typeof window.clarity === 'function') {
      window.clarity('set', 'inp_rating', metric.rating);
      window.clarity('set', 'inp_target', payload.inp_target);
      window.clarity('set', 'inp_value_bucket', value <= 200 ? 'good' : value <= 500 ? 'needs-improvement' : 'poor');
      if (metric.rating !== 'good') {
        window.clarity('event', 'slow-inp');
        window.clarity('upgrade', 'slow-inp');
      }
    }
  });
})();
